<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';

import useBreakpoints from '@exchange/libs/composables/shared/src/lib/useBreakpoints';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';

const FilledOrdersListDesktop = defineAsyncComponent(() => import(/* webpackChunkName: "chunk-filled-order-list-desktop" */ './desktop/FilledOrdersListDesktop.vue'));
const FilledOrdersListMobile = defineAsyncComponent(() => import(/* webpackChunkName: "chunk-filled-order-list-mobile" */ './mobile/FilledOrdersListMobile.vue'));

defineProps({
  authenticatedUser: { type: Boolean, required: true },
  dragging: { type: Boolean, required: true },
  marketId: { type: String, required: true },
  showAllMarkets: { type: Boolean, required: true },
});

const breakpoints = {
  590: 'hide-type compact-side hide-currency', // 'compact-side hide-time hide-currency',
  750: 'hide-type compact-side', // 'compact-side compact-order-type hide-time',
  785: 'hide-type compact-side', // 'compact-side compact-order-type',
  800: 'hide-type compact-side', // 'compact-side',
  bigger: 'hide-type',
};

const { isXS } = useMQBreakpoints();
const { currentBreakPoint, watchedEl: wrapperRef } = useBreakpoints(breakpoints);
</script>

<template>
  <div
    ref="wrapperRef"
    class="filled-orders"
  >
    <filled-orders-list-desktop
      v-if="!isXS"
      class="filled-orders__list"
      list-item-class="filled-orders-list__item"
      :show-order-type="false"
      :authenticated-user="authenticatedUser"
      :breakpoint="currentBreakPoint"
      :dragging="dragging"
      :market-id="marketId"
      :show-all-markets="showAllMarkets"
    />
    <filled-orders-list-mobile
      v-else
      class="filled-orders__list"
      list-item-class="filled-orders-list__item"
      :show-order-type="false"
      :authenticated-user="authenticatedUser"
      :market-id="marketId"
      :show-all-markets="showAllMarkets"
    />
  </div>
</template>

<style lang="scss">
.filled-orders-list__item {
  /** PROFE-110 height: 100%; */
  --advanced-type-color: rgb(var(--v-theme-text-secondary));
  --side-icon-color: var(--side-color);
  --order-side-color: var(--side-color);
  --number-stop-price-color: var(--side-color);

  .xs & {
    --titles-color: rgb(var(--v-theme-text-tertiary));
    --number-amount-color: rgb(var(--v-theme-text-primary));
    --number-price-color: rgb(var(--v-theme-text-primary));
    --number-total-color: rgb(var(--v-theme-text-secondary));
    --market-id-color: rgb(var(--v-theme-text-primary));
    --order-time-color: rgb(var(--v-theme-text-primary));
  }

  &.buy {
    --side-color: rgb(var(--v-theme-success));
  }

  &.sell {
    --side-color: rgb(var(--v-theme-error));
  }
}
</style>
